export default __webpack_public_path__ + "static/media/lock.519e6485.svg";